import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  private endpointPrefix = 'https://qahydragateway.namchat.com/';
  private endpoint = '';
  private microfrontend = false;

  setEndpointPrefix(endpointPrefix: string): void {
    this.endpointPrefix = endpointPrefix;
  }

  setMicrofrontend(microfrontend = true): void {
    this.microfrontend = microfrontend;
  }

  isMicrofrontend(): boolean {
    return this.microfrontend;
  }

  getEndpointFor(api: string, microservice?: string): string {
    if (microservice) {
      return `${this.endpointPrefix}services/${microservice}/${api}`;
    }
    return `${this.endpointPrefix}${api}`;
  }

  getJpaMicroServiceEndpointFor(api: string): string {
    return `${this.endpointPrefix}services/${environment.microService.jpa}/${api}`;
  }

  getMongoMicroServiceEndpointFor(api: string): string {
    return `${this.endpointPrefix}services/${environment.microService.mongo}/${api}`;
  }

  getChatMicroServiceEndpointFor(api: string): string {
    return `${this.endpointPrefix}services/${environment.microService.chat}/${api}`;
  }

  getReportMicroServiceEndpointFor(api: string): string {
    return `${this.endpointPrefix}services/${environment.microService.report}/${api}`;
  }
}
